import { useQuery } from '@tanstack/react-query'

import { ChannelAttendances } from '../../Pages/Home/types/get.channelAttendances'
import { apisiseci } from '../../services/api'

export const CHANNEL_ATTENDANCES_QUERY_KEY = ['channel-attendances'] as const

const useChannelAttendances = () =>
  useQuery<ChannelAttendances[]>({
    queryKey: CHANNEL_ATTENDANCES_QUERY_KEY,
    queryFn: async () => {
      const { data } = await apisiseci.get('/cms/canais_atendimento/')
      return data
    },
    staleTime: 1000 * 60 * 10,
    cacheTime: 1000 * 60 * 30,
  })

export default useChannelAttendances
